module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "personMsg"
  }, [_c('div', {
    staticClass: "photo fl"
  }, [_c('img', {
    staticClass: "head_icon",
    attrs: {
      "src": _vm.avatar,
      "alt": "用户头像"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "alter",
    attrs: {
      "for": "xFile"
    }
  }, [_vm._v("修改头像")]), _vm._v(" "), _c('form', [_c('input', {
    staticStyle: {
      "position": "absolute",
      "clip": "rect(0 0 0 0)"
    },
    attrs: {
      "type": "file",
      "id": "xFile",
      "accept": "image/png, image/jpeg, image/gif, image/jpg"
    },
    on: {
      "change": function($event) {
        _vm.preview($event)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "clear",
    attrs: {
      "id": "preview"
    }
  }), _vm._v(" "), _c('div', [_c('basicMsg', {
    attrs: {
      "userInformation": _vm.userInformation,
      "birthday": _vm.userInformation.birthday,
      "userId": _vm.userId
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "revisePhone"
  }, [_c('p', [_c('img', {
    staticClass: "phone",
    attrs: {
      "src": require("./../assets/img/phone.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "leftSpan"
  }, [_vm._v("绑定手机号：")]), _vm._v(" "), _c('span', {
    staticClass: "rightSpan",
    staticStyle: {
      "color": "#333333"
    }
  }, [_vm._v(_vm._s(_vm.mobile))]), _vm._v(" "), _c('span', {
    staticClass: "bule_alert",
    on: {
      "click": _vm.altMobile
    }
  }, [_vm._v(_vm._s(_vm.buttontext))])])]), _vm._v(" "), _c('div', [_c('alertMobile', {
    attrs: {
      "layerMB": _vm.layerMB,
      "oldMobile": _vm.mobile
    },
    on: {
      "sureMobile": _vm.sureMobile
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectHead"
  }, [_c('span', [_vm._v("个人中心")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ac299fd6","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/personMsg.vue
// module id = 1238
// module chunks = 1